import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ENTER, SPACE } from '@angular/cdk/keycodes';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { map, Observable, startWith } from 'rxjs';

import {PatternElement, allPatterns} from '../../../core/models';
import {parsePattern, patternSample} from '../../../core/helpers/pattern-utils';
import {MatChipInputEvent} from "@angular/material/chips";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";

@Component({
    selector: 'app-pattern-editor',
    templateUrl: './pattern-editor.component.html',
    styleUrls: ['./pattern-editor.component.scss'],
    standalone: false
})
export class PatternEditorComponent implements OnInit, OnChanges {

  @Input() control: FormControl<string>;
  @Input() pattern: string = '';
  @Input() category: string = 'KAT';
  @Output() patternChanged = new EventEmitter<string>();

  separatorKeyCodes: number[] = [ENTER, SPACE];

  patternElements: PatternElement[] = [];
  filteredElements: Observable<PatternElement[]>;
  elementCtrl: FormControl<string> = new FormControl<string>('');
  sample: string = '';

  @ViewChild('elementInput') elementInput: ElementRef<HTMLInputElement>;


  ngOnInit(): void {
    this.filteredElements = this.elementCtrl.valueChanges.pipe(
      startWith(null),
      map((needle: string | null | PatternElement) => {
        return allPatterns.filter(element => {
          // no duplicate elements in pattern
          if (this.patternElements.filter(p => p.value === element.value).length > 0) {
            return false;
          }
          // remove duplicate %<no>-variants
          const hasNoVariant = this.patternElements.some(e => e.value.startsWith('%<no>'));
          if (element.value.startsWith('%<no>') && hasNoVariant) {
            return false;
          }
          // no search text => include other elements
          if (null == needle) {
            return true;
          }
          // some text => include if label starts with search text
          if (typeof needle === 'string') {
            return element.label.startsWith(needle.toLowerCase());
          }
          // needle is selected PatternElement => include if match
          return needle == element;
        })
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pattern']) {
      this.patternElements = parsePattern(this.pattern);
      this.sample = patternSample(this.pattern, this.category);
    }
    if (changes['category']) {
      this.sample = patternSample(this.pattern, this.category);
    }
  }

  drop(event: CdkDragDrop<(PatternElement)[]>) {
    moveItemInArray(this.patternElements, event.previousIndex, event.currentIndex);
    this.refreshPatternAndSample();
  }

  removeElement(element: PatternElement): void {
    this.patternElements.splice(this.patternElements.indexOf(element), 1);
    this.refreshPatternAndSample();
  }

  addElement(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      console.log(event)
      this.patternElements.push({ label: event.value, value: event.value });
      this.refreshPatternAndSample();
    }
    event.chipInput!.clear();
    this.elementCtrl.setValue(null);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.patternElements.push(event.option.value);
    this.refreshPatternAndSample();
    this.elementInput.nativeElement.value = '';
    this.elementCtrl.setValue(null);
  }

  private refreshPatternAndSample(): void {
    const newPattern = this.patternElements.map(element => element.value).join('');
    this.pattern = newPattern;
    this.control.patchValue(newPattern);
    this.patternChanged.emit(newPattern);
    this.sample = patternSample(newPattern, this.category);
    this.elementCtrl.updateValueAndValidity(); // updates selection list of patterns
  }

}
